module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "moduleName": "H5-amywulan-soda-coupon-cell",
  "filePath": "/src/locale/lang",
  "prefix": "soda-coupon-cell---",
  "noParse": false,
  "version": 273,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-amywulan-soda-coupon-cell/src/locale/lang/all.js"
}